const tr = {
  medicalAppointmentActivities: {
    attributes: {
      id: 'Id',
      user_id: 'Usuário',
      user_name: 'Usuário',
      medical_appointment_id: 'Consulta',
      created_at: 'Criado em',
      info: 'Informações',
      platform: 'Plataforma',
    },
    defSingular: 'Atividade',
    defPlural: 'Atividades',
  }
};

export default tr;
